import { Directory } from "../../../../base/domain/drawing";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { StringFilterParameter } from "../../../../base/components/system/filters";

export class EditableFormatSummaryDirectoryFilterParameter {
  constructor(name: string = "") {
    this.name = new StringFilterParameter(name);
  }

  name: StringFilterParameter;

  filter(source: Directory<number, EditableFormatSummary>): boolean {
    return this.name.filter(source.name);
  }

  clone(): EditableFormatSummaryDirectoryFilterParameter {
    return new EditableFormatSummaryDirectoryFilterParameter(this.name.keyword);
  }
}
